/**
Copyright (C) 2022 by SeQuenX  - All Rights Reserved
This file is part of the ComplyVantage product development,
and is released under the "Commercial License Agreement".
You should have received a copy of the Commercial License Agreement license with
this file. If not, please write to: legal@sequenx.com, or visit www.sequenx.com
*/
import React, { useState } from "react";
import { motion } from "framer-motion";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import {
  Shurjeel,
  Saira,
  Zier,
  Aarti,
  jagmeet,
  Murali,
  Shahmir,
  Almas,
  Arsalan,
  Uzair,
  Sheetal,
  chandana,
  Jawad,
  Kamran,
  usama,
  Fazle,
  Raiha,
  sukanya,
  zakwan,
  farhat,
  sri,
  Tehsham,
  aryan,
  rohit,
  swapnil,
  osaid,
  uzair1,
  mehboob,
  akash,
  maryam,
  hamza,
} from "../assets/images";
import { TeamDetailsDialogs } from ".";

const TeamData = [
  {
    name: "Shurjeel Tousif",
    designation: "Founder/CEO",
    description: ".",
    icon: Shurjeel,
    hover: false,
  },
  {
    name: "Saira Naim",
    designation: "Operations Director",
    description: ".",
    icon: Saira,
    hover: false,
  },
  {
    name: "Zier den Heijer",
    designation: "CTO (Chief Technical Architect)",
    description: ".",
    icon: Zier,
    hover: false,
  },
  {
    name: "Aarti Varshney",
    designation: "Director, Recruitment & HR",
    description: ".",
    icon: Aarti,
    hover: false,
  },
  // {
  //   name: "Jagmeet Singh",
  //   designation: "Senior Consultant",
  //   description: ".",
  //   icon: jagmeet,
  //   hover: false,
  // },
  // {
  //   name: "Sri Harsha Katwa",
  //   designation: "Senior Consultant Project Management",
  //   description: ".",
  //   icon: sri,
  //   hover: false,
  // },
  // {
  //   name: "Tehsham Khan",
  //   designation: "Project Partner / Business Development",
  //   description: ".",
  //   icon: Tehsham,
  //   hover: false,
  // },
  // {
  //   name: "Murali Krishna",
  //   designation: "Software Engineering & Services Manager",
  //   description: ".",
  //   icon: Murali,
  //   hover: false,
  // },
  // {
  //   name: "Shahmeer Khan",
  //   designation: "Software Engineer (Team Lead)",
  //   description: ".",
  //   icon: Shahmir,
  //   hover: false,
  // },
  // {
  //   name: "Muhammad Arsalan",
  //   designation: "Software Engineer (Frontend Lead)",
  //   description: ".",
  //   icon: Arsalan,
  //   hover: false,
  // },
  // {
  //   name: "Uzair Khan",
  //   designation: "Software Engineer (Backend)",
  //   description: ".",
  //   icon: Uzair,
  //   hover: false,
  // },
  // {
  //   name: "Hamza Ali",
  //   designation: "Senior Software Engineer (Backend)",
  //   description: ".",
  //   icon: hamza,
  //   hover: false,
  // },
  // {
  //   name: "Almas Shabbir",
  //   designation: "Software Engineer (Backend)",
  //   description: ".",
  //   icon: Almas,
  //   hover: false,
  // },
  // {
  //   name: "Muhammad Kamran",
  //   designation: "DevOps Engineer",
  //   description: ".",
  //   icon: Kamran,
  //   hover: false,
  // },
  // {
  //   name: "Sukanya Nallapa Reddy",
  //   designation: "Java developer",
  //   description: ".",
  //   icon: sukanya,
  //   hover: false,
  // },
  // {
  //   name: "Farhat Ul Ain",
  //   designation: "Software Engineer (Backend)",
  //   description: ".",
  //   icon: farhat,
  //   hover: false,
  // },
  // {
  //   name: "Rohith Kamineni",
  //   designation: "Senior Consultant, Test Automation",
  //   description: ".",
  //   icon: rohit,
  //   hover: false,
  // },
  // {
  //   name: "Swapnil Awachare",
  //   designation: "Camunda BPM Developer",
  //   description: ".",
  //   icon: swapnil,
  //   hover: false,
  // },
  // {
  //   name: "Osaid Arshad",
  //   designation: "Project Manager",
  //   description: ".",
  //   icon: osaid,
  //   hover: false,
  // },
  // {
  //   name: "Aryan Verma",
  //   designation: "Consultant, Data & AI",
  //   description: ".",
  //   icon: aryan,
  //   hover: false,
  // },
  // {
  //   name: "Usama Shabbir",
  //   designation: "Software Engineer (Frontend)",
  //   description: ".",
  //   icon: usama,
  //   hover: false,
  // },
  // {
  //   name: "Uzair Ahmed",
  //   designation: "Software Engineer (Backend)",
  //   description: ".",
  //   icon: uzair1,
  //   hover: false,
  // },
  // {
  //   name: "Akash Arshad",
  //   designation: "Software Engineer (Frontend)",
  //   description: ".",
  //   icon: akash,
  //   hover: false,
  // },
  // {
  //   name: "Muhammad Mehboob",
  //   designation: "Software Engineer (Frontend)",
  //   description: ".",
  //   icon: mehboob,
  //   hover: false,
  // },
  // {
  //   name: "Chandana Rao",
  //   designation: "Open Source Competence Lead",
  //   description: ".",
  //   icon: chandana,
  //   hover: false,
  // },
  // {
  //   name: "Sheetal Deshpande",
  //   designation: "Lead Consultant, SQA & OSS Audit",
  //   description: ".",
  //   icon: Sheetal,
  //   hover: false,
  // },
  // {
  //   name: "Jawad Khan",
  //   designation: "SQA Engineer",
  //   description: ".",
  //   icon: Jawad,
  //   hover: false,
  // },
  // {
  //   name: "Raiha Narmeen",
  //   designation: "SQA Engineer",
  //   description: ".",
  //   icon: Raiha,
  //   hover: false,
  // },
  // {
  //   name: "Fazle Yazdan",
  //   designation: "SQA Engineer",
  //   description: ".",
  //   icon: Fazle,
  //   hover: false,
  // },
  // {
  //   name: "Zakwan Zaib",
  //   designation: "SQA Engineer",
  //   description: ".",
  //   icon: zakwan,
  //   hover: false,
  // },
  // {
  //   name: "Maryem Ashraf",
  //   designation: "SQA Engineer",
  //   description: ".",
  //   icon: maryam,
  //   hover: false,
  // },

  // Other service items...
];

const TeamDetails = () => {
  const [team, setTeam] = useState(TeamData);
  const { t } = useTranslation();

  const handleMouseEnter = (index) => {
    setTeam((prevTeam) => {
      const updatedTeam = [...prevTeam];
      updatedTeam[index].hover = true;
      return updatedTeam;
    });
  };

  const handleMouseLeave = (index) => {
    setTeam((prevTeam) => {
      const updatedTeam = [...prevTeam];
      updatedTeam[index].hover = false;
      return updatedTeam;
    });
  };

  return (
    <section className="py-20">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl font-bold text-gray-800 mb-4 ">
            {t("team.subTitle")}
          </h1>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-8"></div>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto">
            {t("team.description")}
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <Grid container spacing={4} justifyContent="center">
            {team.map((member, index) => (
              <Grid key={index} item xs={12} sm={6} md={4} lg={3}>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="bg-white rounded-xl shadow-lg overflow-hidden transform hover:scale-105 transition-transform duration-300"
                >
                  <div
                    className="relative group"
                    onMouseEnter={() => handleMouseEnter(index)}
                    onMouseLeave={() => handleMouseLeave(index)}
                  >
                    <img
                      src={member.icon}
                      alt={member.name}
                      className="w-full h-54 object-cover"
                    />
                    {member.hover && (
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center"
                      >
                        <TeamDetailsDialogs details={member} />
                      </motion.div>
                    )}
                  </div>
                  <div className="p-4 text-center">
                    <h3 className="text-xl font-bold text-gray-800  mb-2">
                      {member.name}
                    </h3>
                    <p className="text-gray-600">{member.designation}</p>
                  </div>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </motion.div>
      </div>
    </section>
  );
};

export default TeamDetails;
